<template>
  <footer
    class="scroll-links"
    v-if="jewel.description || jewel.video_url"
  >
    <a
      class="scroll-link extra-description-link"
      v-if="jewel.description"
      v-on:click="$emit('scroll-to', 'extra-description')"
    >
      <span>Подробнее</span>
      <font-awesome-icon v-bind:icon="arrowDown"></font-awesome-icon>
    </a>
    <a
      class="scroll-link video-link"
      v-if="jewel.video_url"
      v-on:click="$emit('scroll-to', 'video')"
    >
      <font-awesome-icon v-bind:icon="arrowDown"></font-awesome-icon>
      <span>Видео</span>
    </a>
  </footer>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faChevronCircleDown } from '@fortawesome/free-solid-svg-icons'

export default {
  name: 'CatalogJewelArticleDescriptionScrollLinks',
  components: { FontAwesomeIcon },
  props: ['jewel'],
  data: function () {
    return {
      arrowDown: faChevronCircleDown
    }
  }
}
</script>

<style scoped lang="scss">
  .scroll-links {
    padding-top: 1em;
    padding-right: 1em;
    @include media ("<=mobile") {
      padding-right: 0;
    }
    @media only print {
      display: none;
    }

    & > .extra-description-link {
      float: left;
      margin-left: 0.5em;
    }
    & > .video-link {
      float: right;
      margin-right: 0.5em;
    }
    & > .scroll-link {
      border-bottom: 1px dashed;
      &:only-child {
        float: none;
        @include media ("<=mobile") {
          margin: 0;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/the-content/catalog-jewel-article/catalog-jewel-article-description/CatalogJewelArticleDescriptionScrollLinks.vue